import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";
import ProgressCircle from "./ProgressCircle";
import Divider from "@mui/material/Divider";

const AnyBox3 = ({ name="",PH=0,DO=0,TEMP=0 }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box width="80%" m="0 20px">
      <Box display="flex" justifyContent="start" mt="20px">
        <Typography
          variant="h4"
          fontWeight="bold"
          sx={{ color: colors.grey[100] }}
        >
          {name}
        </Typography>
      </Box>
      <Divider sx={{ mt: "9px" }} />
      <Box display="flex" justifyContent="space-around" mt="30px">
        <Box>
          <Typography
            variant="h5"
            fontWeight="bold"
            sx={{ color: colors.greenAccent[300] }}
          >
            pH value
          </Typography>
          <Typography
            mt="10px"
            variant="h3"
            fontWeight="bold"
            sx={{ color: colors.grey[100], ml: "17px" }}
          >
            {PH}
          </Typography>
        </Box>
        <Box>
          <Typography
            variant="h5"
            fontWeight="bold"
            sx={{ color: colors.blueAccent[300] }}
          >
            DO value
          </Typography>
          <Typography
            mt="10px"
            variant="h3"
            fontWeight="bold"
            sx={{ color: colors.grey[100], ml: "18px" }}
          >
          {DO}
          </Typography>
        </Box>
      </Box>
      <Box display="flex" justifyContent="center" mt="20px">
        <Typography
          variant="h5"
          fontWeight="bold"
          sx={{ color: colors.redAccent[300] }}
        >
          Temperature
        </Typography>
      </Box>
      <Box display="flex" justifyContent="center">
        <Typography
          variant="h3"
          fontWeight="bold"
          mt="10px"
          sx={{ color: colors.grey[100] }}
        >
          {TEMP}
        </Typography>
      </Box>
    </Box>
  );
};

export default AnyBox3;
